import React from "react"
import AccordionCard from "./AccordionCard"
import TestCardProps from "./TestCardProps"
import CardRow from "./CardRow"

export default function ReviewCard(props: TestCardProps) {
  const { data } = props
  return (
    <AccordionCard eventKey="review" title="REVIEW">
      <CardRow title="MRO ID" value={data.MROVendorName}/>
      <CardRow title="MRO NAME" value={data.MROName}/>
      <CardRow title="MRO COPY CCF2 DATE SENT" value={data.MROCopyCCF2Date} date/>
      <CardRow title="MRO COPY CCF2 TIME SENT" value={data.MROCopyCCF2Date} time/>
      <CardRow title="MRO RECEIVED RESULTS DATE" value={data.MROReceivedDate} date/>
      <CardRow title="MRO RECEIVED RESULTS TIME" value={data.MROReceivedDate} time/>
      <CardRow title="MRO RESULTS REPORTED DATE" value={data.MROReportDate} date/>
      <CardRow title="MRO RESULTS REPORTED TIME" value={data.MROReportDate} time/>
    </AccordionCard>
  )
}
